__turbopack_context__.v({
  "centerHeader": "_5-80Aa_centerHeader",
  "container": "_5-80Aa_container",
  "portableText": "_5-80Aa_portableText",
  "size-large": "_5-80Aa_size-large",
  "size-medium": "_5-80Aa_size-medium",
  "size-none": "_5-80Aa_size-none",
  "size-small": "_5-80Aa_size-small",
  "size-xlarge": "_5-80Aa_size-xlarge",
  "sizeMobile-large": "_5-80Aa_sizeMobile-large",
  "sizeMobile-medium": "_5-80Aa_sizeMobile-medium",
  "sizeMobile-none": "_5-80Aa_sizeMobile-none",
  "sizeMobile-small": "_5-80Aa_sizeMobile-small",
  "sizeMobile-xlarge": "_5-80Aa_sizeMobile-xlarge",
});
